import styled from "styled-components";


export const Title = styled.h1`
padding: 15px;
font-size: 28px;
`
export  const SearchWrapper = styled.div`
width: 30%;
@media (max-width: 991.98px){
    width: 60%;
}
padding-top:10px;
padding-bottom: 15px;
`

export const ClearFilterWrapper = styled.div`
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    gap: 5px;
    padding: 20px 0;
`
    
export const ClearFilterButton = styled.div`
    text-decoration: underline;
    cursor: pointer;
`


export const DirectoryHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
`